module.exports = __webpack_public_path__ + "assets/img/18_191_big.5583645c.jpg";